module.exports = __webpack_public_path__ + "img/30.96c6abbe.jpg";